import BusinessIcon from '@mui/icons-material/Business';
import CookieIcon from '@mui/icons-material/Cookie';
import CopyrightIcon from '@mui/icons-material/Copyright';
import GavelIcon from '@mui/icons-material/Gavel';
import LinkIcon from '@mui/icons-material/Link';
import SecurityIcon from '@mui/icons-material/Security';
import StorageIcon from '@mui/icons-material/Storage';
import {
  Box,
  Container,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect } from 'react';
import PageTransition from '../components/PageTransition';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  background: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main,
}));

const MentionsLegales: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageTransition>
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Main Content */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', py: { xs: 6, md: 10 } }}>
          <Container maxWidth="md">
            <StyledPaper>
              <Typography
                variant="h3"
                component="h1"
                gutterBottom
                sx={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  mb: 4,
                  color: 'primary.main',
                  background: 'none',
                  WebkitBackgroundClip: 'unset',
                  WebkitTextFillColor: 'unset',
                }}
              >
                Mentions Légales
              </Typography>

              <Box sx={{ mt: 4 }}>
                <SectionTitle variant="h5">
                  <BusinessIcon fontSize="large" />
                  1. Informations légales
                </SectionTitle>
                <List>
                  <ListItem>
                    <ListItemText primary="Éditeur du site" secondary="Jukobox SAS" />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Siège social"
                      secondary="123 Avenue de la Musique, 75001 Paris, France"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="SIRET" secondary="123 456 789 00012" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Email" secondary="contact@jukebox.com" />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Directeur de la publication"
                      secondary="Jean Dupont - Directeur Général"
                    />
                  </ListItem>
                </List>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <StorageIcon fontSize="large" />
                  2. Hébergement
                </SectionTitle>
                <List>
                  <ListItem>
                    <ListItemText primary="Hébergeur" secondary="Amazon Web Services (AWS)" />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Adresse"
                      secondary="410 Terry Avenue North, Seattle, WA 98109-5210, États-Unis"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Contact" secondary="support@aws.com" />
                  </ListItem>
                </List>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <CopyrightIcon fontSize="large" />
                  3. Propriété intellectuelle
                </SectionTitle>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  L'ensemble de ce site relève de la législation française et internationale sur le
                  droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction
                  sont réservés, y compris pour les documents téléchargeables et les représentations
                  iconographiques et photographiques.
                </Typography>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  La reproduction de tout ou partie de ce site sur un support électronique quel
                  qu'il soit est formellement interdite sauf autorisation expresse de Jukobox.
                </Typography>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <SecurityIcon fontSize="large" />
                  4. Protection des données personnelles
                </SectionTitle>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée et au
                  Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit
                  d'accès, de rectification et de suppression des données vous concernant.
                </Typography>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  Pour exercer ce droit, veuillez nous contacter à l'adresse suivante :
                  privacy@jukebox.com
                </Typography>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <CookieIcon fontSize="large" />
                  5. Cookies
                </SectionTitle>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  Le site utilise des cookies nécessaires à son fonctionnement et des cookies de
                  mesure d'audience. En naviguant sur ce site, vous acceptez leur utilisation. Pour
                  plus d'informations, consultez notre politique de cookies.
                </Typography>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <LinkIcon fontSize="large" />
                  6. Liens externes
                </SectionTitle>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  Le site peut contenir des liens vers d'autres sites. Jukobox n'est pas responsable
                  du contenu des sites vers lesquels des liens sont établis. Ces liens sont établis
                  de bonne foi et Jukobox ne peut être tenu responsable des modifications apportées
                  sur ces sites.
                </Typography>

                <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

                <SectionTitle variant="h5">
                  <GavelIcon fontSize="large" />
                  7. Droit applicable
                </SectionTitle>
                <Typography paragraph sx={{ pl: 2, color: 'text.secondary' }}>
                  Les présentes mentions légales sont soumises au droit français. Tout litige
                  relèvera de la compétence exclusive des tribunaux français. Les tribunaux de Paris
                  seront seuls compétents en cas de litige.
                </Typography>
              </Box>
            </StyledPaper>
          </Container>
        </Box>
      </Box>
    </PageTransition>
  );
};

export default MentionsLegales;
